import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FeedMetadataService } from '../../../../services/feed-metadata.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FeedMetadataUpdateRequest } from '../../../../../models/feed-override.model';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { OverrideDialogComponent } from './override-dialog/override-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-feed-product-detail',
  standalone: true,
  templateUrl: './feed-product-detail.component.html',
  styleUrls: ['./feed-product-detail.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    RouterLink,
    MatSlideToggle,
    CommonModule,
    MatSelectModule
  ]
})
export class FeedProductDetailComponent implements OnInit {

  productId!: number;
  destination!: string;
  destinations: any[] = [];

  loading = false;
  saving = false;

  fieldDefinitions: any[] = [];
  overrideData: any = {};
  isExcluded = false;

  form!: FormGroup;
  product: any = null;
  fieldConfig: any[] = [];
  overrideDestinationId!: number;



  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private feedService: FeedMetadataService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  async ngOnInit() {
    this.productId = Number(this.route.snapshot.paramMap.get('productId'));
    this.destination = this.route.snapshot.queryParamMap.get('destination') || '';

    this.loading = true;
    this.form = null as any; // prevent template from binding early

    this.destinations = await this.feedService.getFeedDestinations();
    this.product = await this.feedService.getProductById(this.productId.toString());
    this.fieldConfig = await this.feedService.getDestinationFieldConfig(this.destination);

    const overrides = await this.feedService.getOverridesForProductDestination(
      this.productId.toString(),
      this.destination
    );

    if (overrides.length > 0) {
      const ov = overrides[0];
      this.overrideDestinationId = ov.destination_id;
      this.isExcluded = ov.is_excluded;
      this.overrideData = ov.override_data;
    } else {
      const match = this.destinations.find(d => d.code === this.destination);
      this.overrideDestinationId = match?.destination_id;
      this.overrideData = {};
      this.fieldConfig.forEach(f => this.overrideData[f.key] = '');
      this.isExcluded = false;
    }

    this.buildForm();
    this.loading = false;
  }



  buildForm() {
    const group: any = {};

    this.fieldConfig.forEach(field => {
      group[field.key] = new FormControl(
        this.overrideData[field.key] ?? '',
        field.required ? Validators.required : []
      );
    });

    group['is_excluded'] = new FormControl(this.isExcluded);

    this.form = new FormGroup(group);
  }


  async save() {
    this.openConnectDialog(this.form.value);
  }

  onDestinationChange(newDest: string) {
    this.destination = newDest;

    this.router.navigate([], {
      queryParams: { destination: newDest },
      relativeTo: this.route
    });

    this.ngOnInit();
  }

  openConnectDialog(payload: any) {
    const dialogRef = this.dialog.open(OverrideDialogComponent, {
      width: '450px',
      data: {
        productName: this.product?.name,
        destinationName: this.destination
      }
    });

    dialogRef.afterClosed().subscribe(async confirm => {
      if (confirm) {
        if (this.saving) return;

        this.saving = true;

        const payload: FeedMetadataUpdateRequest = {
          destination_id: this.overrideDestinationId.toString(),
          override_data: this.form.value,
          is_excluded: this.form.value['is_excluded']
        };

        await this.feedService.upsertFeedMetadata(this.productId.toString(), payload);

        this.saving = false;
        this.router.navigate(['/admin/manage-feeds'], {
          queryParams: { tab: 'feeds' }
        });
      }
    });

  }

}
